"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EMAIL_PREBUILT_BLOCK_PLACEHOLDER_COPY = exports.EMAIL_EVENT_PLACEHOLDER_COPY = exports.EMAIL_TODAYS_DATE_FORMAT = exports.EMAIL_FOOTER_TEXT = exports.EMAIL_MIRROR_LINK_TEXT = void 0;
const locales_1 = require("../enums/locales");
exports.EMAIL_MIRROR_LINK_TEXT = {
    [locales_1.Locales.EN]: "View in browser",
    [locales_1.Locales.FR]: "Voir dans le navigateur",
    [locales_1.Locales.ES]: "Ver en el navegador",
    [locales_1.Locales.DE]: "Im Browser ansehen",
};
exports.EMAIL_FOOTER_TEXT = {
    [locales_1.Locales.EN]: {
        sentWith: "Sent with",
        tagline: "100% free all-in-one fundraising platform for nonprofits",
        unsubscribe: "Unsubscribe from these emails",
        learnMore: "Learn more about Zeffy",
    },
    [locales_1.Locales.FR]: {
        sentWith: "Envoyé avec",
        tagline: "Plateforme de collecte de fonds tout-en-un, 100 % gratuite pour les OBNL",
        unsubscribe: "Vous désabonner de ces courriels",
        learnMore: "En savoir plus sur Zeffy",
    },
    [locales_1.Locales.ES]: {
        sentWith: "Enviado con",
        tagline: "Plataforma de recaudación de fondos todo en uno, 100 % gratuita para organizaciones sin fines de lucro",
        unsubscribe: "Desuscribirse de estos correos",
        learnMore: "Más información sobre Zeffy",
    },
    [locales_1.Locales.DE]: {
        sentWith: "Gesendet mit",
        tagline: "100 % kostenlose All-in-One-Fundraising-Plattform für gemeinnützige Organisationen",
        unsubscribe: "Diese E-Mails abbestellen",
        learnMore: "Mehr über Zeffy erfahren",
    },
};
exports.EMAIL_TODAYS_DATE_FORMAT = {
    [locales_1.Locales.FR]: "d LLLL yyyy",
    [locales_1.Locales.EN]: "LLLL d yyyy",
    [locales_1.Locales.ES]: "LLLL d yyyy",
    [locales_1.Locales.DE]: "d. LLLL yyyy",
};
exports.EMAIL_EVENT_PLACEHOLDER_COPY = {
    [locales_1.Locales.EN]: { date: "Event date", location: "Event location", time: "Event time", name: "the event" },
    [locales_1.Locales.FR]: {
        date: "Date de l'événement",
        location: "Lieu de l'événement",
        time: "Heure de l'événement",
        name: "l'événement",
    },
    [locales_1.Locales.ES]: { date: "Fecha del evento", location: "Lugar del evento", time: "Hora del evento", name: "el evento" },
    [locales_1.Locales.DE]: {
        date: "Datum der Veranstaltung",
        location: "Ort der Veranstaltung",
        time: "Uhrzeit der Veranstaltung",
        name: "der Veranstaltung",
    },
};
exports.EMAIL_PREBUILT_BLOCK_PLACEHOLDER_COPY = {
    [locales_1.Locales.EN]: {
        title: "Title",
        description: "Description",
        imageCaption: "Image caption",
        bodyText: "Updates to share",
        buttonLabel: "Call to action",
    },
    [locales_1.Locales.FR]: {
        title: "Titre",
        description: "Description",
        imageCaption: "Légende de l'image",
        bodyText: "Nouvelles à partager",
        buttonLabel: "Appel à l'action",
    },
    [locales_1.Locales.DE]: {
        title: "Titel",
        description: "Beschreibung",
        imageCaption: "Bildbeschriftung",
        bodyText: "Neuigkeiten zum Teilen",
        buttonLabel: "Handlungsaufruf",
    },
};
